export const FOLDED_2025_TRACKING_EVENTS = {
	launchedFromDesktopNavbar: 'BM: Folded 2025 launched from desktop navbar',
	launchedFromMobileNavbar: 'BM: Folded 2025 launched from mobile navbar',
	launchedFromDirectLink: 'BM: Folded 2025 launched from direct link',
	viewedIntroScreen: 'BM: Folded 2025 viewed intro screen',
	viewedRevenueScreen: 'BM: Folded 2025 viewed revenue screen',
	viewedCustomersScreen: 'BM: Folded 2025 viewed customers screen',
	viewedTeamScreen: 'BM: Folded 2025 viewed team screen',
	viewedMachinesScreen: 'BM: Folded 2025 viewed machines screen',
	viewedFeatureFactsScreen: 'BM: Folded 2025 viewed feature facts screen',
	viewedFinaleScreen: 'BM: Folded 2025 viewed finale screen',
	clickedBarryCta: 'BM: Folded 2025 clicked Barry AI button',
};
